var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

export default isEvent;


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/events/isEvent.js
// module id = Q3gb
// module chunks = 1